var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.666,
    height: 17.745,
    viewBox: "0 0 17.666 17.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8673166_ic_fluent_edit_filled_icon",
    "data-name": "8673166_ic_fluent_edit_filled_icon",
    d: "M15.349,1.172a3.621,3.621,0,0,1,2.577,1.068A3.3,3.3,0,0,1,18.891,5a5.569,5.569,0,0,1-1.749,3.177l-.328.327h0L8.244,17.077A2.575,2.575,0,0,1,7.1,17.74L2.964,18.868a1.352,1.352,0,0,1-1.436-.487A1.345,1.345,0,0,1,1.3,17.2l1.129-4.139a2.575,2.575,0,0,1,.662-1.141l8.367-8.368h0l1.316-1.315A3.621,3.621,0,0,1,15.349,1.172Zm1.234,5.387A3.526,3.526,0,0,0,17.4,4.828,1.777,1.777,0,0,0,16.866,3.3a2.145,2.145,0,0,0-3.034,0l-.255.254Zm-1.89,1.947L11.659,5.473l-7.51,7.51a1.072,1.072,0,0,0-.276.475l-1.063,3.9,3.9-1.063a1.072,1.072,0,0,0,.475-.276Z",
    transform: "translate(-1.249 -1.172)",
    fill: "#4663ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditar);
export default __webpack_public_path__ + "static/media/ico-editar.1a2c063e9112dc8b2c459263b71d1c01.svg";
export { ForwardRef as ReactComponent };